const wordsToCheck = [
  '死ね',
  '殺す',
  '覚醒剤',
  'シャブ',
  '大麻',
  'マリファナ',
  'MDMA',
  '合成麻薬',
  'うんち',
  'ちんこ',
  'チンコ',
  'まんこ',
  'マンコ',
  '援助交際',
  '円光',
]

export const anyNgWordIncluded = (s: string): boolean => {
  return wordsToCheck.some((word) =>
    s.toLowerCase().includes(word.toLowerCase())
  )
}
